import { render, staticRenderFns } from "./DetalharAtividade.vue?vue&type=template&id=1c053057&scoped=true&"
import script from "./DetalharAtividade.vue?vue&type=script&lang=js&"
export * from "./DetalharAtividade.vue?vue&type=script&lang=js&"
import style0 from "./DetalharAtividade.vue?vue&type=style&index=0&id=1c053057&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c053057",
  null
  
)

export default component.exports